import { Button, mergeClassnames } from '@heathmont/moon-core-tw';
import useIsBottomNavigation from '~/client/hooks/useIsBottomNavigation';
import useIsBombayClubTheme from '~/client/layout/GamesLayout/hooks/useIsBombayClubTheme';
import Translate from '~/client/shared/i18n/Translate';

type Props = {
  href?: string;
  onClick?: () => void;
  isLink?: boolean;
  hasShadow?: boolean;
};

const SigninButtonView: FC<Props> = ({
  href,
  hasShadow,
  onClick,
  isLink = false,
}) => {
  const { isBombayClubTheme } = useIsBombayClubTheme();
  const isBottomNavigation = useIsBottomNavigation();
  const variant =
    isBombayClubTheme && isBottomNavigation ? 'ghost' : 'secondary';
  return (
    <Button
      as={isLink ? 'a' : undefined}
      variant={variant}
      href={href}
      onClick={onClick}
      fullWidth
      className={mergeClassnames(
        'font-normal',
        !hasShadow && 'shadow-none hover:shadow-none',
        isBombayClubTheme && isBottomNavigation ? 'h-8 text-bulma' : '',
      )}
    >
      <Translate id="profile.login" />
    </Button>
  );
};

export default SigninButtonView;
